module.exports = __webpack_public_path__ + "static/media/pequeno_prazer_5.f5f61aad.jpg";